import { render, staticRenderFns } from "./customerListing.vue?vue&type=template&id=f2de0a52&"
import script from "./customerListing.vue?vue&type=script&lang=js&"
export * from "./customerListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports